import { render, staticRenderFns } from "./DataKerabat.vue?vue&type=template&id=7924cc2f&"
import script from "./DataKerabat.vue?vue&type=script&lang=js&"
export * from "./DataKerabat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports